import { TagsList } from "@components/Listings/ListingsFilter/components/ListingsFilterCheckboxList"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"
import { originNames } from "@utils/const"
import Image from "next/image"
import styles from "@components/Listings/ListingsFilter/ListingsFilter.module.scss"
import { originImgURL } from "@components/Listings/listings-page-utils"

const origins = [
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcresalemarket"]} alt="dvcresalemarket" width="22" height="22" />
                {originNames.dvcresalemarket}
            </>
        ),
        key: "dvcresalemarket"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcshop"]} alt="dvcshop" width="22" height="22" />
                {originNames.dvcshop}
            </>
        ),
        key: "dvcshop"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcstore"]} alt="dvcstore" width="22" height="22" />
                {originNames.dvcstore}
            </>
        ),
        key: "dvcstore"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["fidelityresales"]} alt="fidelityresales" width="22" height="22" />
                {originNames.fidelityresales}
            </>
        ),
        key: "fidelityresales"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcresaleexperts"]} alt="dvcresaleexperts" width="22" height="22" />
                {originNames.dvcresaleexperts}
            </>
        ),
        key: "dvcresaleexperts"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcsales"]} alt="dvcsales" width="22" height="22" />
                {originNames.dvcsales}
            </>
        ),
        key: "dvcsales"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["resalesdvc"]} alt="resalesdvc" width="22" height="22" />
                {originNames.resalesdvc}
            </>
        ),
        key: "resalesdvc"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcbyresale"]} alt="dvcbyresale" width="22" height="22" />
                {originNames.dvcbyresale}
            </>
        ),
        key: "dvcbyresale"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["vacatia"]} alt="vacatia" width="22" height="22" />
                {originNames.vacatia}
            </>
        ),
        key: "vacatia"
    },
    // {
    //     children: (
    //         <>
    //             <Image className={styles.partnerImg} src={originImgURL["dvctimeshares"]} alt="dvctimeshares" width="22" height="22" />
    //             {originNames.dvctimeshares}
    //         </>
    //     ),
    //     key: "dvctimeshares"
    // },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcadvantages"]} alt="dvcadvantages" width="22" height="22" />
                {originNames.dvcadvantages}
            </>
        ),
        key: "dvcadvantages"
    },
    /*    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["atimeshare"]} alt="atimeshare" width="22" height="22" />
                A timeshare
            </>
        ),
        key: "atimeshare"
    },*/
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["buyandselldvc"]} alt="buyandselldvc" width="22" height="22" />
                {originNames.buyandselldvc}
            </>
        ),
        key: "buyandselldvc"
    }
]

export function TagsOrigin() {
    const onTagListChange = useFilterStore((s) => s.onTagListChange)
    const selectedItems = useFilterStore((s) => s.origin_in)

    return <TagsList selectedItems={selectedItems} items={origins} onItemChange={onTagListChange("origin")} title="Resale Broker" />
}
